// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.56 7.02L10.14 4.58',
  'M5.56 8.98L10.14 11.42',
  'M5.8 8C5.8 9.16 4.86 10.1 3.7 10.1C2.54 10.1 1.6 9.16 1.6 8C1.6 6.84 2.54 5.9 3.7 5.9C4.86 5.9 5.8 6.84 5.8 8Z',
  'M14.1 3.6C14.1 4.76 13.16 5.7 12 5.7C10.84 5.7 9.9 4.76 9.9 3.6C9.9 2.44 10.84 1.5 12 1.5C13.16 1.5 14.1 2.44 14.1 3.6Z',
  'M14.1 12.4C14.1 13.56 13.16 14.5 12 14.5C10.84 14.5 9.9 13.56 9.9 12.4C9.9 11.24 10.84 10.3 12 10.3C13.16 10.3 14.1 11.24 14.1 12.4Z',
];
